module.exports = __webpack_public_path__ + "img/banner-together-mobile-n.0289c02e.jpg";